import { Nullable } from '@f-fertighaus/applications/Next/types/utility'

export type EmptyString = ''

export function isNotEmptyString<T extends string>(
  variable: Nullable<EmptyString | T>
): variable is T {
  return Boolean(
    variable && typeof variable === 'string' && variable.length > 0
  )
}
